module.exports = {
  path: 'sign-up',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/SignUp').default || require('./components/SignUp'));
    }, 'signup');
  }
};



// WEBPACK FOOTER //
// ./routes/signUp/index.js